import { FundriseRouteConfig } from 'vue-router';
import { PrivateInvestorDocumentRedirectParams } from 'types/investor-documents';
import { privateInvestorDocumentViewRedirect } from '@api/private-document-redirect';

const privateDocumentRedirectRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/shareholder-documents/:id/view',
		name: 'shareholder-document-view',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: async (to, from, next) => {
			const params: PrivateInvestorDocumentRedirectParams = {
				documentId: to.params.id,
				documentType: 'SHAREHOLDER'
			};

			try {
				const redirectLink = await privateInvestorDocumentViewRedirect(params);
				window.location.href = redirectLink.presignedUrl;
			} catch {
				next({ name: 'account-overview', replace: true });
			}
		}
	},
	{
		path: '/investor-verification-documents/:id/view',
		name: 'investor-verification-document-view',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: async (to, from, next) => {
			const params: PrivateInvestorDocumentRedirectParams = {
				documentId: to.params.id,
				documentType: 'INVESTOR_VERIFICATION'
			};

			try {
				const redirectLink = await privateInvestorDocumentViewRedirect(params);
				window.location.href = redirectLink.presignedUrl;
			} catch {
				next({ name: 'account-overview', replace: true });
			}
		}
	},
	{
		path: '/identification-documents/:id/view',
		name: 'identification-document-view',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: async (to, from, next) => {
			const params: PrivateInvestorDocumentRedirectParams = {
				documentId: to.params.id,
				documentType: 'IDENTIFICATION'
			};

			try {
				const redirectLink = await privateInvestorDocumentViewRedirect(params);
				window.location.href = redirectLink.presignedUrl;
			} catch {
				next({ name: 'account-overview', replace: true });
			}
		}
	}
];

export default privateDocumentRedirectRoutes;
